import { Box, Stack, Typography } from '@mui/material';

/** Minimal why / what preview for What's happening — full brief lives in verification details. */
export function ConcernWhyWhatTeaser({
  why,
  what,
  accent,
}: {
  why: string;
  what?: string | null;
  accent: string;
}) {
  const whyText = why.trim();
  const whatText = what?.trim() ?? '';
  if (!whyText && !whatText) return null;

  return (
    <Stack spacing={0.85}>
      {whyText ? (
        <Box>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 800,
              letterSpacing: 0.35,
              textTransform: 'uppercase',
              color: accent,
              display: 'block',
              mb: 0.25,
              fontSize: '0.75rem',
            }}
          >
            Why
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, lineHeight: 1.5, fontSize: '0.8125rem', color: 'text.primary' }}
          >
            {whyText}
          </Typography>
        </Box>
      ) : null}
      {whatText ? (
        <Box>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 800,
              letterSpacing: 0.35,
              textTransform: 'uppercase',
              color: accent,
              display: 'block',
              mb: 0.25,
              fontSize: '0.75rem',
            }}
          >
            What to do
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, lineHeight: 1.5, fontSize: '0.8125rem', color: 'text.primary' }}
          >
            {whatText}
          </Typography>
        </Box>
      ) : null}
    </Stack>
  );
}
